import * as Yup from 'yup';
import { requiredField } from './utils/messages';

export const createPdvValidationSchema = Yup.object().shape({
  custom_id: Yup.string().required(requiredField),
  name: Yup.string().required(requiredField),
  operation_id: Yup.mixed().required(requiredField),
  is_totem: Yup.boolean(),
});
